import { Form } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'

import './Checkbox.scss'

const CheckBoxComponent2 = ({ label, setCheckBoxStatus, value, name, dir, dmode}) => {
  const { t } = useTranslation()
  const reverse = dir === 'rtl' ? true : false
  return (
    <>
      <Form.Group dir={dir}>
        <Form.Check
          className={`checkbox-st ${dmode? 'v2-dark-checkbox':''}`}
          type="checkbox"
          reverse={reverse}
          label={t(label)}
          name={name}
          onChange={(e) => setCheckBoxStatus(name, e.target.checked)}
        />
      </Form.Group>
    </>
  )
}

export default CheckBoxComponent2
